var $body = $('body');
new WOW().init();
document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});
$(document).ready(function () {

    // Navbar expand
    navbar_expand();

    // Animation slider
    var animSlider = $('.anim-slider');
    if (animSlider.length) {
        if (animSlider.find('.anim-slide').length > 1) {
            animSlider.animateSlider({
                autoplay: true, //starts the autoplay 
                interval: 10,
                elemAnimate: true,
                animations: {
                    0: {
                        ".subheadline": {
                            show: "slideInUp",
                            hide: "slideOutDown",
                            delayShow: "delay1s"
                        },
                        ".headline": {
                            show: "slideInDown",
                            hide: "slideOutUp",
                            delayShow: "delay1-5s"
                        },
                        li: {
                            show: "fadeIn",
                            hide: "fadeOut",
                            delayShow: "delay2s"
                        }
                    },
                    1: {
                        ".subheadline": {
                            show: "slideInLeft",
                            hide: "slideOutRight",
                            delayShow: "delay1s"
                        },
                        ".headline": {
                            show: "slideInRight",
                            hide: "slideOutLeft",
                            delayShow: "delay1-5s"
                        },
                        li: {
                            show: "fadeIn",
                            hide: "fadeOut",
                            delayShow: "delay2s"
                        }
                    }
                }
            });
            $('.anim-arrows').show();
        } else {
            animSlider.show();
            $('.anim-arrows').hide();
        }
    }
    //Mobile Menu
    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('menu--open');
        nav_height();
    });

    //mobile navigation
    $('.nav-arrow').on('click', function () {
        $(this).parent().siblings('li').removeClass('sub--open').find('ul').slideUp();
        $(this).parent().toggleClass('sub--open').find('ul').first().slideToggle();
    });

    // Go to bottom
    $('.scroll-down').bind('click', function (event) {
        $('html, body').stop().animate({
            scrollTop: ($(this).parent().next('section').offset().top - 55)
        }, 800);
        event.preventDefault();
    });

    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
        return false;
    });
    // Search Text Toggle
    $('.search-btn').click(function () {
        $('.navigation').toggleClass('search-show');
    });

    //testimonial carousel    
    var testimonialSlider = $('.testimonial-slider-int');
    if (testimonialSlider.length) {
        if (testimonialSlider.find('.testimonial-slide').length > 1) {
            testimonialSlider.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                loop: true,
                autoplay: true,
                onInitialize: function () {
                    if (testimonialSlider.find('.testimonial-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            testimonialSlider.show();
        }
    }

    //sponsor carousel    
    var sponsorSlider = $('.sponsors-slider');
    if (sponsorSlider.length) {
        if (sponsorSlider.find('.sponsors-slide').length > 1) {
            sponsorSlider.owlCarousel({
                items: 6,
                margin: 30,
                nav: true,
                dots: false,
                loop: true,
                autoplay: true,
                responsive: {
                    0: {
                        items: 2
                    },
                    575: {
                        items: 3
                    },
                    767: {
                        items: 4
                    },
                    991: {
                        items: 5
                    },
                    1200: {
                        items: 6
                    }
                },
                onInitialize: function () {
                    if (sponsorSlider.find('.sponsors-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            sponsorSlider.show();
        }
    }

    //postSlider
    var postSlider = $('.related-post-slider');
    if (postSlider.length) {
        if (postSlider.find('.related-post-slide').length > 1) {
            postSlider.owlCarousel({
                nav: true,
                dots: false,
                margin: 20,
                autoplay: true,
                loop: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    767: {
                        items: 2
                    },
                    991: {
                        items: 3
                    }
                }
            });
        } else {
            postSlider.show();
        }
    }
});
$(window).resize(function () {
    nav_height();
    /*isotope_masonry Function*/
    isotope_masonry();
});
$(window).on('load', function () {
    /*isotope_masonry Function*/
    isotope_masonry();
    //Preloader JS code
    $('.status').delay(100).fadeOut(); // will first fade out the loading animation 
    $('.preloader').delay(100).fadeOut('slow'); // will fade out the white DIV that covers the website. 
    $('body').delay(100).css({ 'overflow': 'visible' });
});
var stickyOffset = $('header').height();
var previousScroll = 0;
var topHeader = $('.top-header').outerHeight();
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // Fixed Menu
    if (scroll >= topHeader) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }

    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
    } else {
        $('.goto-top').removeClass('visible');
    }

    // code for counter 
    if ($('.counter-section').length) {
        var count_scroll = $('.counter-section').offset().top - win_height();
        if (scroll > count_scroll) {
            $('.animation-counter').each(function (index) {
                init_odometer(this);
            });
        }
    }
});

function nav_height() {
    if (win_width() > 991) {
        $('.navigation').css('height', 'auto');
        $('.navigation').css('margin-top', 0);
    } else {
        $('.navigation').css('height', win_height() - header_height() + 1);
        $('.navigation').css('margin-top', header_height() - 1);
    }
}
function win_height() {
    return $(window).outerHeight();
}
function win_width() {
    return $(window).width();
}
function header_height() {
    return $('header.page').outerHeight();
}

function navbar_expand() {
    if ($(window).width() >= 992) {
        $('.has-sub-menu').hover(function () {
            $(this).children('.sub-menu-list').toggleClass('has-menu-open');
        });
    } else {
        $('.menu-toggle-ico').click(function () {
            $(this).toggleClass('rotate-ico');
            $(this).siblings('.sub-menu-list').toggleClass('has-menu-open');
            $(this).siblings('.mega-sub-menu').toggleClass('has-menu-open');
            $(this).siblings('.grid-menu').toggleClass('has-menu-open');
        });
    }
}
/*Odometer Function*/
function init_odometer(el) {
    if ($('.animation-counter-odometer', el).size() == 0)
        return;
    var odometer = $('.animation-counter-odometer', el).get(0);
    var format = $(el).closest('.animation-counter-box').data('number-format');
    format = format ? format : '(ddd).ddd';
    var od = new Odometer({
        el: odometer,
        value: $(odometer).text(),
        format: format
    });
    od.update($(odometer).data('to'));
}
/*isotope_masonry Function*/
function isotope_masonry() {
    //portfolio Isotope plugins initialize
    $GalleryGrid = $('.gallery-grid').isotope({
        itemSelector: '.gallery-grid-item',
        layoutMode: "packery",
    });
    // filter items on button click
    $('.js-filter').on('click', 'button', function () {
        var filterValue = $(this).attr('data-filter');
        $GalleryGrid.isotope({
            filter: filterValue
        });
        $('.js-filter button').removeClass('is-active');
        $(this).addClass('is-active');
    });

    //portfolio Isotope plugins initialize
    $eventGrid = $(".event-grid").isotope({
        layoutMode: "packery",
        itemSelector: ".event-grid-item"
    });
    // filter items on button click
    $('.js-filter').on('click', 'button', function () {
        var filterValue = $(this).attr('data-filter');
        $eventGrid.isotope({
            filter: filterValue
        });
        $('.js-filter button').removeClass('is-active');
        $(this).addClass('is-active');
    });
}